import axios, { AxiosResponse } from "axios";
import { ArrayFromEnvelope, configService, ObjectFromEnvelope } from "./config.service";
import { EmploymentStatement } from "../models/employmentStatements";

class EmploymentStatementsService {
  async fetchEmployementStatementByEmployeeId(employeeId: number): Promise<EmploymentStatement[]> {
    return new Promise((resolve, reject) => {
      axios
        .get<EmploymentStatement[]>(configService.APIInstitutionUrl("employment_statements.json"), {
          params: {
            employee_id: employeeId
          }
        })
        .then((response: AxiosResponse) => {
          resolve(
            EmploymentStatement.fromJSONArray(ArrayFromEnvelope<EmploymentStatement>(response.data))
          );
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  async createEmploymentStatement(
    employmentStatement: EmploymentStatement,
    overtime: boolean,
    isOk11: boolean,
    isHourlyPaid: boolean,
    useEmploymentSoCalculation: boolean
  ): Promise<EmploymentStatement> {
    return new Promise((resolve, reject) => {
      if (isHourlyPaid) {
        axios
          .post<EmploymentStatement>(
            configService.APIInstitutionUrl(
              "employment_statements.json?use_employment_so_value=" + useEmploymentSoCalculation
            ),
            employmentStatement.convertToPostHourlyPaidOvertimeObject()
          )
          .then((response: AxiosResponse) => {
            resolve(
              EmploymentStatement.fromJSON(ObjectFromEnvelope<EmploymentStatement>(response.data))
            );
          })
          .catch((error) => reject(error));
      } else if (overtime && !isOk11) {
        axios
          .post<EmploymentStatement>(
            configService.APIInstitutionUrl(
              "employment_statements.json?use_employment_so_value=" + useEmploymentSoCalculation
            ),
            employmentStatement.convertToPostOvertimeObject()
          )
          .then((response: AxiosResponse) => {
            resolve(
              EmploymentStatement.fromJSON(ObjectFromEnvelope<EmploymentStatement>(response.data))
            );
          })
          .catch((error) => reject(error));
      } else if (!overtime && !isOk11) {
        axios
          .post<EmploymentStatement>(
            configService.APIInstitutionUrl(
              "employment_statements.json?use_employment_so_value=" + useEmploymentSoCalculation
            ),
            employmentStatement.convertToPostObject()
          )
          .then((response: AxiosResponse) => {
            resolve(
              EmploymentStatement.fromJSON(ObjectFromEnvelope<EmploymentStatement>(response.data))
            );
          })
          .catch((error) => reject(error));
      } else if (overtime && isOk11) {
        axios
          .post<EmploymentStatement>(
            configService.APIInstitutionUrl("employment_statements.json"),
            employmentStatement.convertToPostOK11OvertimeObject()
          )
          .then((response: AxiosResponse) => {
            resolve(
              EmploymentStatement.fromJSON(ObjectFromEnvelope<EmploymentStatement>(response.data))
            );
          })
          .catch((error) => reject(error));
      } else {
        //OK11 no overtime
        axios
          .post<EmploymentStatement>(
            configService.APIInstitutionUrl("employment_statements.json"),
            employmentStatement.convertToOK11PostObject()
          )
          .then((response: AxiosResponse) => {
            resolve(
              EmploymentStatement.fromJSON(ObjectFromEnvelope<EmploymentStatement>(response.data))
            );
          })
          .catch((error) => reject(error));
      }
    });
  }

  async deleteEmploymentStatement(employmentStatementId: number): Promise<any> {
    return new Promise((resolve, reject) => {
      axios
        .delete<EmploymentStatement>(
          configService.APIInstitutionUrl(
            "employment_statements/" + employmentStatementId + ".json"
          )
        )
        .then((response: AxiosResponse) => {
          resolve(response.data);
        })
        .catch((error) => reject(error));
    });
  }
}

export const employmentStatementsService: EmploymentStatementsService =
  new EmploymentStatementsService();
